import { action, observable } from 'mobx'
import Base from './base'

export default class ConfigStore extends Base {
  /** locale language */
  @observable language = 'ID'
  /** close download */
  @observable isClose = false
  /** ---- */
  @observable screenWidth = -1
  /** ---- */
  @observable screenHeight = -1
  /** category/tag id */
  @observable categoryId = -1
  @observable tagId = -1

  /** banner data */
  @observable bannerData = null

  @action setLanguage(language: string) {
    this.language = language
  }

  @action setClose(isClose: boolean) {
    this.isClose = isClose
  }

  @action setScreenWidth(width: number) {
    this.screenWidth = width
  }

  @action setScreenHeight(height: number) {
    this.screenHeight = height
  }

  @action setCategoryId(payload: number) {
    this.categoryId = payload
  }

  @action setTagId(payload: number) {
    this.tagId = payload
  }

  @action setBannerData(payload: any) {
    this.bannerData = payload
  }
}

export const NewConfigStore = new ConfigStore()
